import React, { useEffect } from "react";
import styles from "./accounting.module.css";
import logo from "../../img/nobat-logo.png";
import { useState } from "react";
import { Icon, Radio, Button, message } from "antd";
import { useRef } from "react";
import axios from "axios";

const Factor = (props) => {
  const pincode = props.match.params.pincode;

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dateValue, setDateValue] = useState("");
  const [format, setFormat] = useState(1);
  const [date, setDate] = useState([]);

  useEffect(() => {
    getFactorData();
  }, []);

  const getFactorData = async () => {
    const formData = new FormData();
    formData.set("pincode", pincode);
    let config = {
      method: "post",
      data: formData,
      url: window.server + "/accounting/factors/list",
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      let response = await axios(config);
      let res = response.data;
      setDate(res);
    } catch (error) {
      console.log(error);
    }
  };

  const getExcelAction = () => {
    if (dateValue == 0) {
      message.error("دوره  را انتخاب کنید");
      return;
    }
    // if(endDate.length == 0) {
    //   message.error("تاریخ پایان را وارد کنید")
    //   return
    // }
    let url = `${window.server}/accounting/factors/download?pincode=${pincode}&period=${dateValue}`;
    window.open(url, "_blank");
  };

  const getCustometListAction = () => {
    let url = `${window.server}/accounting/customer-list?pincode=${pincode}`;
    window.open(url, "_blank");
  };

  return (
    <div className={styles.main}>
      <div className={styles.box}>
        <img src={logo} />
        {/* <div className={styles.date_box}>
          <div className={styles.input_date_box}>
            <Icon type="calendar" />
            <input 
              ref={startDateRef}
              type="text"
              placeholder="تاریخ شروع : ۱۴۰۱/۱۲/۱"
              value={startDate}
              onChange={ e => setStartDate(e.target.value)}
            />
          </div>
          <div className={styles.input_date_box}>
            <Icon type="calendar" />
            <input 
              ref={endDateRef}
              type="text"
              placeholder="تاریخ پایان : ۱۴۰۱/۱۲/۱۵"
              value={endDate}
              onChange={ e => setEndDate(e.target.value)}
            />
          </div>
        </div> */}
        <div className={styles.radio_box}>
          <select
            className={styles.select_box}
            onChange={(e) => {
              setDateValue(e.target.value);
            }}
          >
            <option value={0}> انتخاب دوره ... </option>
            {date.map((val) => {
              return <option value={val.value}> {val.text} </option>;
            })}
          </select>
        </div>
        <div className={styles.btn_box}>
          <Button
            className="mt-3"
            type="primary"
            onClick={() => getExcelAction()}
          >
            دریافت فایل
          </Button>
          {/* <Button
            className="my-3"
            type="primary"
            onClick={ () => getCustometListAction() }
          >
            لیست همه مشتریان
          </Button> */}
        </div>
      </div>
    </div>
  );
};

export default Factor;
